// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receipt {
  width: 80mm;
  font-family: Arial, sans-serif;
  font-size: 8px;
  padding: 10px;
}

.receipt h2 {
  text-align: center;
}

.receipt .item {
  display: flex;
  justify-content: space-between;
}

.receipt .total {
  text-align: right;
}

.company-info {
  text-align: center;
  border-bottom: 1px dashed #000;
}

.company-info img {
  width: 150px;
}

.company-name {
  font-weight: bold;
  font-size: 12px;
  margin-top: 8px;
}

.app-details {
  text-align: center;
}
.bill-info {
  display: flex;
  justify-content: space-between;
  padding: 5px;
  border-bottom: 1px dashed #000;
}
.product-info {
  border-bottom: 1px dashed #000;
  padding: 5px;
}
table {
  width: 100%;
  border-bottom: 1px dashed #000;
}

tfoot {
  border-top: 1px dashed #000;
}

.shop-details {
  text-align: center;
  font-size: 9px;
  border-bottom: 1px dashed #000;
  padding: 5px;
}

.store-info {
  text-align: center;
  padding: 5px;
  border-bottom: 1px dashed #000;
}

.store-name {
  font-size: 10px;
  font-weight: bold;
}

.bill-details {
  text-align: center;
  padding: 5px;
  border-bottom: 1px dashed #000;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/print-layout/print-layout.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC","sourcesContent":[".receipt {\n  width: 80mm;\n  font-family: Arial, sans-serif;\n  font-size: 8px;\n  padding: 10px;\n}\n\n.receipt h2 {\n  text-align: center;\n}\n\n.receipt .item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.receipt .total {\n  text-align: right;\n}\n\n.company-info {\n  text-align: center;\n  border-bottom: 1px dashed #000;\n}\n\n.company-info img {\n  width: 150px;\n}\n\n.company-name {\n  font-weight: bold;\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n.app-details {\n  text-align: center;\n}\n.bill-info {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px;\n  border-bottom: 1px dashed #000;\n}\n.product-info {\n  border-bottom: 1px dashed #000;\n  padding: 5px;\n}\ntable {\n  width: 100%;\n  border-bottom: 1px dashed #000;\n}\n\ntfoot {\n  border-top: 1px dashed #000;\n}\n\n.shop-details {\n  text-align: center;\n  font-size: 9px;\n  border-bottom: 1px dashed #000;\n  padding: 5px;\n}\n\n.store-info {\n  text-align: center;\n  padding: 5px;\n  border-bottom: 1px dashed #000;\n}\n\n.store-name {\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.bill-details {\n  text-align: center;\n  padding: 5px;\n  border-bottom: 1px dashed #000;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
